import getCsrfToken from "../../lib/csrfToken";

export async function registerJob(setting) {
  const url = window.Urls['manual_api:add_job']();

  const data = new FormData();
  data.append('setting', JSON.stringify(setting));

  const headers = new Headers();
  const token = getCsrfToken();
  if (token !== undefined) {
    headers.set('X-CSRFToken', token);
  }

  const resp = await fetch(url, {
    method: 'POST',
    headers: headers,
    body: data
  });

  const ret = await resp.json();
  return ret['jobId'];
}

export async function getPrefs() {
  const url = window.Urls['manual_api:prefs']();

  const resp = await fetch(url);
  const data = await resp.json();
  return data['data'];
}

export async function getMunicipalities(pref_id) {
  const url = window.Urls['manual_api:municipalities'](pref_id);

  const resp = await fetch(url);
  const data = await resp.json();
  return data['data'];
}

export async function getOptional(area_id) {
  const url = window.Urls['manual_api:optional'](area_id);

  const resp = await fetch(url);
  return resp.json();
}
